import { Routes, Route } from "react-router-dom";

import Homepage from "./Pages/Home";
import DetailPage from "./Pages/Detail";
import AboutUsPage from "./Pages/AboutUs";
import ContactPage from "./Pages/Contact";
import RechnerPage from "./Pages/Rechner";
import BewertungPage from "./Pages/Bewertung";
import { ChatBubble } from "./Components";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/detail/:city" element={<DetailPage />} />
        <Route path="/filter" element={<DetailPage />} />
        <Route path="/about_us" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/rechner" element={<RechnerPage />} />
        <Route path="/bewertung" element={<BewertungPage />} />
      </Routes>
      <ChatBubble />
    </>
  );
}

export default App;